import { atom } from "recoil";

export const languageAtom = atom<string | undefined>({
  key: "language",
  default: undefined,
});
